import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';

import { ComponentLoaderDirective } from '../../lib-directives/component-loader/component-loader.directive';
import { AppModalInterface } from '../../lib-interfaces/app-modal.interface';

@Component({
  selector: 'lib-offcanvas-wrapper',
  templateUrl: './offcanvas-wrapper.component.html',
  styleUrls: ['./offcanvas-wrapper.component.scss']
})
export class OffcanvasWrapperComponent implements OnInit {

  @ViewChild(ComponentLoaderDirective, { static: true }) component_loader!: ComponentLoaderDirective;

  // Component must implement AppModalInterface
  @Input() component: any;
  @Input() component_properties: Record<string, any> = {};

  constructor(
    public activeOffcanvs: NgbActiveOffcanvas
  ) { }

  ngOnInit(): void {
    this.loadComponent();
  }

  loadComponent() {
    const view_container_ref = this.component_loader.view_container_ref;
    view_container_ref.clear();

    const component_instance = view_container_ref.createComponent(this.component).instance as AppModalInterface;

    for (const key of Object.keys(this.component_properties)) {
      component_instance[key] = this.component_properties[key];
    }

    component_instance.close.subscribe((result) => {
      this.activeOffcanvs.close(result);
    });
    component_instance.dismiss.subscribe(() => {
      this.activeOffcanvs.dismiss();
    });
  }

}
